import { Box, Typography, alpha, useTheme } from '@mui/material';
import Row from 'components/base/row';
import { useIsMobile } from 'hooks/useIsMobile';
import React from 'react';

export default function CategoryItem({
  color,
  name,
  onClick,
  isDisabled,
}: {
  color: string;
  name: string;
  onClick: () => void;
  isDisabled: boolean;
}) {
  const theme = useTheme();

  const isMobile = useIsMobile();

  const width = isMobile ? 'auto' : 165;
  const height = isMobile ? 'auto' : 54;

  return (
    <Row
      className="noselect"
      onClick={onClick}
      sx={{
        width,
        height,
        alignItems: 'center',
        flexGrow: 1,
        borderRadius: 100,
        border: 1,
        borderColor: isDisabled ? 'transparent' : color,
        bgcolor: isDisabled
          ? theme.palette.customBackgrounds.elevation6
          : alpha(color, 0.45),
        py: 3,
        pl: 2.5,
        pr: 4,
        gap: 2.5,
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: 100,
          bgcolor: color,
          flexShrink: 0,
        }}
      ></Box>
      <Typography variant="f14">{name}</Typography>
    </Row>
  );
}
